module.exports = __webpack_public_path__ + "assets/fbe8cd4635cea6e3e0b83b907d58746b.svg";